import axios from "axios";
import cutemobi from "../../router/cutemobi";
import country_list from "../../locales/country_list.json";
import $ from "jquery";

const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();
const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_cm");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el' || parts[0] =='gr'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}



// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_cm: {},
  //auth
  auth_cm: "",
  //main.vue
  //hotpicks.vue
  pageHP_cm: {},
  //popular.vue
  pagePop_cm: {},
  //notification.vue
  notification_cm: {},
  //icon
  hotpickIcon_cm: require(`../../assets/cutemobi/imgs/other/Hot Picks.svg`),
  popularIcon_cm: require(`../../assets/cutemobi/imgs/other/Populars.svg`),
  langButton_cm: ``,
  country_cm: parts[0],
  host_cm: host,
  // lang_cm: localStorage.getItem("lang_cm"),
  lang_cm: brwlang,
  type: 'browse',
  gcid_cm: gcid,
  hpisLoad_cm: false,
  renew_date_cm: '',
  subscription_date_cm: '',
  msisdn_cm: '',
  country_code_cm: '',
  gateway_code_cm: '',
  is_unsub: '0',
};

const getters = {
  langButton_cm: state => state.langButton_cm,
  lang_cm: state => state.lang_cm,
  gcid_cm: state => state.gcid_cm,
  country_cm: state => state.country_cm,
  allSubcategory_cm: state => state.allsubcategory_cm,
  pageHotPicks_cm: state => state.pageHP_cm,
  pagePopular_cm: state => state.pagePop_cm,
  HotPickIcon_cm: state => state.hotpickIcon_cm,
  PopularIcon_cm: state => state.popularIcon_cm,
  notification_cm: state => state.notification_cm,
  host_cm: state => state.host_cm,
  auth_cm: state => state.auth_cm,
  hpisLoad_cm: state => state.hpisLoad_cm,
  renew_date_cm: state => state.renew_date_cm,
  subscription_date_cm: state => state.subscription_date_cm,
  msisdn_cm: state => state.msisdn_cm,
  country_code_cm: state => state.country_code_cm,
  gateway_code_cm: state => state.gateway_code_cm,
  is_unsub_cm: state => state.is_unsub,
};

const actions = {
  async fetchLocale_cm({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_cm({commit}, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_cm({commit}, subcategory){
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );
    
    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_cm({ commit }, file) {
    let data = file[0]

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = []

    if(data == undefined){
      response = await axios.get(
        `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    }else{
      response = await axios.get(
        `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a,b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    )

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_cm({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort((a,b) =>
      // a.content_name.localeCompare(b.content_name),
      b.rating - a.rating
    )

    commit("setPagePopular", response.data.data);
  },
  async fetchToken_cm({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_cm");
    let userProfile = localStorage.getItem("userProfile_cm");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }
    
    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }
    
    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_cm", auth);
      // console.log(check)
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      cutemobi.push({ name: "Login" }).catch(err => {});
    }
    
    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userToken_cm", data.code);
        commit("setUserProfile", JSON.parse(userProfile));
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let responses = await axios.post(
          `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
         
        );
        var response = JSON.parse(responses.data.contents);
        if (response.status == "active") {
          localStorage.setItem("userToken_cm", data.code);
          localStorage.setItem("userProfile_cm", responses.data.contents)
          commit("setUserProfile", response);
          commit("setAuth", "loggedin");
          cutemobi.push({ path: path }).catch(err => {});
          // location.reload();
        } else if (response.status == "inactive") {
          if(data.code != undefined){
            alert(response.status.toUpperCase())
          }
          cutemobi.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      cutemobi.push({ name: "Login" }).catch(err => {});
    }
  },
  async getDomain_cm({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

    let dom= response.data.data
    dom = dom.filter(item =>{
      return item.domain == host;
    })

    let domain = ""

    if(dom != ""){
      domain = dom[0].is_unsub;

      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{
      domain = '0'
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_cm({ commit }, auth) {
    var letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_cm({ commit }, file) {
    let token = localStorage.getItem("userToken_cm");
    let lang = localStorage.getItem("lang_cm");
    let alert_pop = "";
    
    let alert_lang = require(`../../locales/cutemobi/${lang}.json`);
    alert_pop = alert_lang.not_subs;
    
    if (token != null) {
      if (file[1] != 'application/x-zip-compressed') {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_cm,
          product: 'cutemobi',
          content_id: file[2],
          type: "download"
        })
        window.location.href = file[0];
        // window.open(file[0], "download");
      } else {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_cm,
          product: 'cutemobi',
          content_id: file[2],
          type: "play"
        })

        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        cutemobi.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async login_cm({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_cm({ commit }) {
    let notify =[]
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if(w != 0){
      date = date + 10
    }
    
    let res = await axios.get(
      `${state.live}/api/contents/cutemobi_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );
    let data = res.data.data;
    let noti = data.map((noti) =>{
      noti.titleSub_english = noti.subcategory
      if(noti.subcategory_translate != null){
        let sub_trans = JSON.parse(noti.subcategory_translate)
        if(sub_trans != null){
          let trans_len = Object.keys(sub_trans).length
          let trans_arr = Object.keys(sub_trans)
          
          if(sub_trans != null || sub_icon != null){
            for(let i = 0; i<trans_len; i++){
                noti['titleSub_'+trans_arr[i]] = sub_trans[trans_arr[i]].title
            }
          }
        }
      }
      return noti;
    })

    // if(w == 0){
    //   //name ascending
    //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    // }else{
    //   //name descending
    //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    // }

    notify = noti.slice(0,5);

    commit("setNotification", notify);
  },
  async logout_cm({commit}, is_unsub){
    if(is_unsub != '0'){
      let token = localStorage.getItem("userToken_cm")
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_code_cm}/${state.gateway_code_cm}/unsub.php?code=${token}&msisdn=${state.msisdn_cm}`));
      removeStorage()
      console.log(responses.data)
      var response = JSON.parse(responses.data.contents); 
      $("#exampleModalCenter").modal("hide");
      if(responses.data.contents == 'success' || response.status =='success'){
        if (state.country_cm == 'iq') {
          cutemobi.push({ name: 'Unsubscription'}).catch(err => {});
        } else {
          cutemobi.push({ name: 'Login'}).catch(err => {});
        }
      }
    }else{
      removeStorage();
      if (state.country_cm == 'iq') {
        $("#exampleModalCenter").modal("hide");
        cutemobi.push({ name: 'Unsubscription'}).catch(err => {});
      } else {
        cutemobi.push({ name: 'Login'}).catch(err => {});
      }
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_cm");
      localStorage.removeItem("userToken_cm");
      localStorage.removeItem("logged-in");
      commit("setAuth", "");
    } 
    
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_cm = response),
  setPagePopular: (state, response) => (state.pagePop_cm = response),
  setNotification: (state, response) => (state.notification_cm = response),
  setAuth: (state, response) => (state.auth_cm = response),
  setButton: (state, response) => (state.langButton_cm = response),
  setLanguage: (state, response) => (state.lang_cm = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_cm = response),
  setUserProfile: (state, response) => (
    state.renew_date_cm = response.next_renew_date,
    state.subscription_date_cm = response.subscription_date,
    state.msisdn_cm = response.msisdn,
    state.country_code_cm = response.country_code,
    state.gateway_code_cm = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_cm = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
};
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cutemobi-store.js